export default {
  role: {
    roleId: 'ID',
    roleName: 'Tên phân quyền',
    description: 'Mô tả',
    role: "Phân quyền"
  }
};
